/* eslint-disable @typescript-eslint/no-explicit-any */
import LAMBDA_INVOCATION_TEMPLATE from './model-invocation-template.json';
import { ILambdaHttpConfig } from '../../../interfaces';

function createLambdaPayload(httpConfig: ILambdaHttpConfig = {}) {
    const queryParams = httpConfig.queryParams || {};
    const queryStringParameters: any = {};
    for (const key in queryParams) {
        if (Object.hasOwnProperty.call(queryParams, key)) {
            const value = queryParams[key];
            queryStringParameters[key] = Array.isArray(value)
                ? value[0]
                : value;
        }
    }

    const payload = {
        ...LAMBDA_INVOCATION_TEMPLATE,
        body: httpConfig.body,
        headers: httpConfig.headers,
        multiValueQueryStringParameters: queryParams,
        queryStringParameters,
    };

    let payloadString = JSON.stringify(payload);

    payloadString = payloadString
        .replace(/\$PATH/g, httpConfig.path || '/') // Path replacement
        .replace(/\$HTTP_METHOD/g, httpConfig.method || 'GET'); // HTTP method replacement

    return payloadString;
}

export { createLambdaPayload };
